import { instance } from '@/libs/api/instance'

export const getBeneficiary = async (id) => {
  return instance.get(`/v1/beneficiary/${id}`, {
    params: {
      expand: ['address', 'address.country', 'currency'].join(','),
    },
  })
}
